import React, { useState, useEffect } from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import useAxios from 'hooks/useAxios';
import TaskBoardTable from './components/TaskBoardTable';

const TaskBoard = (props) => {
    const { orgId } = props;
    const API = useAxios();
    return (
        <div>
            <Container fluid className='width_info'>
                <div>
                    <Card className='border-0 shadow-top'>
                        <CardBody className=''>
                            <ErrorBoundary>
                                <TaskBoardTable
                                    orgId={orgId}
                                />
                            </ErrorBoundary>
                        </CardBody>
                    </Card>
                </div>
            </Container>
        </div>
    );

}

export default TaskBoard;